import { useState, useId, useEffect } from "react";
import { useCombobox } from "downshift";
import { useSpinDelay } from "spin-delay";
import { getOrderList } from "../../../services/inventory";

export const useOrderComboBox = ({ onChange, defaultOrderId = null }) => {
  const id = useId();
  const [orders, setOrders] = useState([]);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingDefaultOrder, setIsLoadingDefaultOrder] = useState(false);

  const combobox = useCombobox({
    id,
    onSelectedItemChange: ({ selectedItem }) => {
      onChange(selectedItem);
      setSelectedOrder(selectedItem);
    },
    items: orders,
    itemToString: (item) => (item ? item?.id : ""),
    onInputValueChange: (changes) => {
      if (changes.inputValue) {
        handleFetchOrders(changes.inputValue);
      }
    },
  });

  const displayMenu = combobox.isOpen && orders.length > 0;
  const showSpinner = useSpinDelay(isLoading, {
    delay: 150,
    minDuration: 500,
  });

  const handleFetchOrders = (query) => {
    setIsLoading(true);
    getOrderList(`?query=${query}`)
      .then((response) => {
        setOrders(response?.data?.data);
        setIsLoading(false);
      })
      .catch(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    if (!defaultOrderId) return;

    setIsLoadingDefaultOrder(true);
    getOrderList(`?query=${defaultOrderId}`)
      .then((response) => {
        const matchedOrder = response?.data?.data?.find(
          (order) => `${order?.id}` === `${defaultOrderId}`,
        );

        if (matchedOrder) {
          setSelectedOrder(matchedOrder);
          onChange(matchedOrder);
        }
      })
      .finally(() => setIsLoadingDefaultOrder(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultOrderId]);

  return {
    combobox,
    displayMenu,
    orders,
    selectedOrder,
    isLoading,
    showSpinner,
    isLoadingDefaultOrder,
  };
};
